import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import {FormattedMessage} from 'react-intl';

export default class ResetPasswordDialog extends React.Component {

   constructor(props) {
      super(props);
      this.state = {email: "", valid:false};
      this.emailCheckRE=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
   }

   handleClose = () => {
      this.props.handleClose();
      this.setState.state = {email: "", valid:false};
   }

   resetPassword = () => {
      this.props.resetPassword(this.state.email);
      this.props.handleClose();
   }

   updateEmail = (event, value) => {
      this.setState({email:value, valid:this.emailCheckRE.test(value)});
   }

   render() {
      const actions = [
         <FlatButton
            label= {<FormattedMessage id="general.cancelText"/>}
            onTouchTap={this.handleClose.bind(this)}
            primary={true}
         />,
         <FlatButton
            label= {<FormattedMessage id="general.send"/>}
            onTouchTap={this.resetPassword.bind(this)}
            primary={true}
            disabled = {!this.state.valid}
         />
      ]
      return (
         <Dialog
            actions = {actions}
            modal={false}
            open={this.props.open}
            title={
               <div className="dialogTitleClass">
                  <FormattedMessage id="resetPassword.title"/>
               </div>
            }
            underlineFocusStyle = {{'display': 'inline', 'borderColor':'rgba(0,0,0,0.54)'}}
            floatingLabelFocusStyle = {{'color':'rgba(0,0,0,0.54)'}}
            contentStyle={{width: "25%", maxWidth: "none"}}
         >
            <p><FormattedMessage id="resetPassword.explanation"/></p>
            <TextField
               type="email"
               floatingLabelText={<FormattedMessage id = "resetPassword.emailInputTitle"/>}
               floatingLabelFixed={true}
               onChange={this.updateEmail.bind(this)}
               value={this.state.email}
               autoFocus={true}
               name="emailTitle"
            />
         </Dialog>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/resetPasswordDialog.component.js